import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSocket } from "../../helper/socket";

// Async action to send autoPlay data via socket
export const sendAutoPlayData = createAsyncThunk(
    "autoPlay/send",
    async (data, { rejectWithValue }) => {
        return new Promise((resolve, reject) => {
            const socket = getSocket();
            try {
                socket.emit("autoSpin", data); // Send data to server

                socket.once("autoSpin", (response) => {
                    resolve(response); // Resolve with server response
                });

                // Handle timeout case
                setTimeout(() => reject(rejectWithValue("No response from server")), 5000);
            } catch (error) {
                reject(rejectWithValue(error.message));
            }
        });
    }
);

const autoPlaySlice = createSlice({
    name: "autoPlay",
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetAutoPlay: (state) => {
            state.data = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendAutoPlayData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sendAutoPlayData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(sendAutoPlayData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetAutoPlay } = autoPlaySlice.actions;
export default autoPlaySlice.reducer;
